// Per-page <title> and meta description: written into each page's HTML at
// build time (see prerender in main.tsx) and kept in step on client-side
// navigation.
import { useEffect } from 'preact/hooks';

export const DEFAULT_TITLE = 'shotmeal — snap a meal, know the calories';
export const DEFAULT_DESCRIPTION =
  'Snap a meal and AI estimates the calories, protein, carbs and more in seconds. Follow your weight from Apple Health or Health Connect and keep a diary for the whole household. Free to start, no account needed.';

/** What the page being prerendered declared — read by `prerender` in
 *  main.tsx to write that page's <title> and description into its HTML. */
export const ssrHead = { title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION };

export function resetSsrHead() {
  ssrHead.title = DEFAULT_TITLE;
  ssrHead.description = DEFAULT_DESCRIPTION;
}

export function usePageMeta(title: string, description: string = DEFAULT_DESCRIPTION) {
  // Effects don't run when prerendering, so record it during render instead.
  if (typeof window === 'undefined') {
    ssrHead.title = title;
    ssrHead.description = description;
  }
  useEffect(() => {
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', description);
  }, [title, description]);
}
